/**
 * Trims a value if of type string, otherwise returns the value.
 *
 * @param {*} value Value to trim if it is a string.
 * @returns {*} Trimmed string if value is a string, otherwise value.
 */
const trimIfString = (value) => (typeof value === 'string' ? value.trim() : value);

export default trimIfString;
